import confetti from 'canvas-confetti';

export const celebrate = (options = {}) => confetti({
    particleCount: 100,
    spread: 180,
    scalar: 0.8,
    origin: {y: 0.35},
    gravity: 0.9,
    disableForReducedMotion: true,
    ...options,
});
